// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1z3he","unreadBadge":"styles_unreadBadge__1DQkr","modalContent":"styles_modalContent__1fSHG","modal":"styles_modal__3jEXa"};